export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-400 mb-6">About Us</p>
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mb-8">
              Not an agent.<br />Not a middleman.<br />
              <span className="text-teal-400">The actual buyer.</span>
            </h2>
            <p className="text-gray-400 text-xl leading-relaxed mb-6">
              ReadyBuyer Group is a buyers group network based in Melbourne. We buy properties for ourselves — then add value and on-sell to first home buyers, downsizers, and upgraders looking for the right home.
            </p>
            <p className="text-gray-400 text-lg leading-relaxed">
              Because we&apos;re buying for our own network, we have genuine skin in the game. Every deal matters to us. That&apos;s why we move fast, make fair offers, and don&apos;t waste anyone&apos;s time.
            </p>
          </div>

          {/* Right — differentiators */}
          <div className="space-y-px">
            {[
              {
                num: '01',
                title: 'We buy for ourselves',
                desc: 'Not a buyers agency. Not representing someone else. We are the buyer — which means no delays, no approvals chain, no uncertainty.',
              },
              {
                num: '02',
                title: 'Finance approved & ready',
                desc: 'We don\'t need to arrange finance after making an offer. We\'re ready to move the moment you say yes.',
              },
              {
                num: '03',
                title: 'Anywhere in Melbourne',
                desc: 'Our SureBuy agents cover all of Melbourne. We come to you — you don\'t need to do a thing.',
              },
              {
                num: '04',
                title: 'Zero cost to you',
                desc: 'No selling fees. No marketing costs. No staging bills. What we offer is what you get.',
              },
            ].map((item) => (
              <div
                key={item.num}
                className="flex gap-6 p-6 rounded-xl hover:bg-white/5 transition-colors group cursor-default"
              >
                <span className="text-xs font-bold text-teal-600 mt-1 w-6 flex-shrink-0">{item.num}</span>
                <div>
                  <h3 className="font-bold text-white text-lg mb-1 group-hover:text-teal-300 transition-colors">{item.title}</h3>
                  <p className="text-gray-500 text-base leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
